import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "list", "checkbox", "option"]

  connect() {
    // Set initial priorities for checked items
    this.optionTargets.forEach(option => {
      const checkbox = option.querySelector("input[type='checkbox']")
      if (checkbox.checked) {
        option.dataset.priority = "1"
      } else {
        option.dataset.priority = "2"
      }
    })
    
    this.sortOptions()
  }

  filter() {
    const searchTerm = this.normalizeString(this.searchTarget.value)
    let visibleCount = 0
    
    this.optionTargets.forEach(option => {
      const label = this.normalizeString(option.querySelector("label").textContent)
      const checkbox = option.querySelector("input[type='checkbox']")
      const isChecked = checkbox.checked
      
      if (isChecked) {
        option.style.display = ""
        option.dataset.priority = "1"
        visibleCount++
      } else if (searchTerm === "" || label.includes(searchTerm)) {
        option.style.display = ""
        option.dataset.priority = "2"
        visibleCount++
      } else {
        option.style.display = "none"
        option.dataset.priority = "3"
      }
    })
    
    // Hide the list container if no results
    const listContainer = this.listTarget.parentElement
    if (visibleCount === 0) {
      listContainer.style.display = "none"
    } else {
      listContainer.style.display = ""
    }
    
    this.sortOptions()
  }

  normalizeString(str) {
    // Convert to lowercase and remove accents/diacritics
    return str.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  }

  sortOptions() {
    const options = Array.from(this.optionTargets)
    const sortedOptions = options.sort((a, b) => {
      const priorityA = parseInt(a.dataset.priority || "2")
      const priorityB = parseInt(b.dataset.priority || "2")
      
      if (priorityA !== priorityB) {
        return priorityA - priorityB
      }
      
      const labelA = a.querySelector("label").textContent
      const labelB = b.querySelector("label").textContent
      return labelA.localeCompare(labelB)
    })
    
    sortedOptions.forEach(option => {
      this.listTarget.appendChild(option)
    })
  }

  checkboxChanged(event) {
    // Reset search field when an option is selected
    this.searchTarget.value = ""
    this.filter()
  }
}